import React      from "react"
import LineBase   from "./line_base"

// Components
import Buttons      from "./shared/buttons"
import Calculations from "./shared/calculations"
import Inputs       from "./shared/inputs"
import Option       from "./shared/option"
import HideInPdf    from "./shared/hide_in_pdf"
import Inactive     from "./line_inactive"
import Combobox     from "@shared/combobox"
import QuillInput   from '@shared/quillInput'

// Helpers
import { getRequest, pathname }     from '@helpers/javascript/javascript'
import { resolveVatRate }           from "@shared/quotes/resolveVatRate"
import { lineNameFor, roundNumber, offBpuCoefficient } from "../helpers"

export default class Product extends LineBase {
  constructor(props) {
    super(props)
    this.state             = {...this.state}
    this.onChange          = this.onChange.bind(this)
    this.reset             = this.reset.bind(this)
    this.selectProduct     = this.selectProduct.bind(this)
    this.changeDescription = this.changeDescription.bind(this)
  }

  onChange(productId) {
    const path   = `/quotes/form/${productId}/product`
    const format = "json"
    const params = {line_type: "Qline"}
    if (this.props.quote.client.id) params.client = this.props.quote.client.id
    const url = pathname({ path, format, params })

    getRequest(url).then(this.selectProduct)
  }

  reset() {
    const { index, qline } = this.props
    const { replaceLine }  = this.props.buttonProps

    replaceLine({...qline, product: {}}, index)
  }

  changeDescription(description) {
    const { replaceLine }  = this.props.buttonProps
    const { index, qline } = this.props

    replaceLine({...qline, description}, index)
  }

  selectProduct(product) {
    const { index, qline } = this.props
    const { replaceLine }  = this.props.buttonProps

    let purchase_price = product.purchase_price
    let unit_price     = product.sale_price

    const has_unit_price     = unit_price     > 0
    const has_purchase_price = purchase_price > 0
    const allow_markup       = this.props.quote.allow_markup
    const markup             = this.props.quote.price_markup_coefficient
    
    const vat_rate = resolveVatRate(this.props.quote.site, product, this.props.quote.vat_rate)

    // Marché-linked quote with off-BPU tiers → tier coefficient drives the
    // sale price from the product's purchase price (overrides allow_markup).
    const tiers = this.props.quote.mbc_off_bpu_tiers
    if (this.props.quote.mbc_contract?.id && has_purchase_price && tiers && tiers.length > 0) {
      const coef = offBpuCoefficient(purchase_price, tiers)
      if (coef != null) unit_price = roundNumber(purchase_price * coef)
    } else if (allow_markup && has_unit_price && !has_purchase_price) {
      purchase_price = roundNumber(unit_price / markup)
    } else if (allow_markup && !has_unit_price && has_purchase_price) {
      unit_price     = roundNumber(purchase_price * markup)
    }

    replaceLine({
      ...qline,
      description:         product.html,
      ref_product_distrib: product.ref_product_brand,
      unit:                product.unit,
      vat_rate:            vat_rate,
      cost_category:       product.cost_category || qline.cost_category,
      product,
      purchase_price,
      unit_price
    }, index)
  }

  render() {
    const { index, quote, qline, vats, showCode, showMargin, buttonProps } = this.props
    const { replaceLine, showCostCategory, overheadCoefs, overheadCoef } = this.props.buttonProps
    const useRevient = !!showCostCategory && !!qline.cost_category
    const lineCat    = qline.cost_category
    const lineCoef   = (overheadCoefs && lineCat && overheadCoefs[lineCat] != null)
                         ? parseFloat(overheadCoefs[lineCat])
                         : (parseFloat(overheadCoef) || 0)

    return(
      qline.active
      ? <div className="quotes--form-qline-container">
          <React.Fragment>
            <div className="quotes--form-full-row">
              <label>{I18n.t("quotes.new.product")}</label>
              { qline.product.id
                ? <div onClick={this.reset}>
                    <input
                      className="form-control mb-3"
                      defaultValue={qline.product.name}
                      disabled
                    />

                    <input
                      type="hidden"
                      defaultValue={qline.product.id}
                      name={lineNameFor("product_id", index)}
                    />
                  </div>
                : <Combobox
                    identifier      = "id"
                    feed            = "/products/autocomplete.json"
                    onSelectElement = {prod => this.onChange(prod.id)}
                    className       = "combobox--new mb-3"
                  />
              }
            </div>

            <div className="text-input">
              <QuillInput
                text={qline.description}
                name={lineNameFor('description', index)}
                onChange={this.changeDescription}
              />
            </div>

            <Calculations
              qline={qline}
              index={index}
              replaceLine={replaceLine}
              showMargin={showMargin}
              showPriceCoefficient={quote.allow_markup}
              useRevient={useRevient}
              overheadCoef={lineCoef}
            />

            <Inputs
              index={index}
              quote={quote}
              qline={qline}
              replaceLine={replaceLine}
              vats={vats}
              showMargin={showMargin}
              useRevient={useRevient}
              overheadCoef={lineCoef}
            />

            <div className="checkboxes">
              <Option
                index={index}
                qline={qline}
                replaceLine={replaceLine}
              />

              <HideInPdf
                index={index}
                qline={qline}
                replaceLine={replaceLine}
              />
            </div>

            <Buttons
              index={index}
              qline={qline}
              buttonProps={buttonProps}
            />

            <input
              type="hidden"
              name={lineNameFor("id", index)}
              defaultValue={qline.id}
            />

            <input
              type="hidden"
              name={lineNameFor("order", index)}
              defaultValue={index + 1}
            />
          </React.Fragment>
        </div>
      : <Inactive
          index={index}
          qline={qline}
          showCode={showCode}
          buttonProps={buttonProps}
        />
    )
  }
}
